var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.537 18.528l-21.6-17.28a1.412 1.412 0 00-1.8 0l-21.6 17.28c-.36.288-.576.72-.576 1.152v23.04a4.333 4.333 0 004.32 4.32h37.44a4.333 4.333 0 004.32-4.32V19.68c0-.432-.216-.864-.504-1.152zM3.84 24.36l12.384 8.28L3.84 40.92V24.36zm5.04 1.656V20.4h30.24v5.616l-8.64 5.76-6.048-4.032a.78.78 0 00-.792 0l-6.12 4.032-8.64-5.76zM44.16 42.72c0 .792-.648 1.44-1.44 1.44H5.28c-.792 0-1.44-.648-1.44-1.44v-.072L24 29.184l20.16 13.464v.072zm0-1.8l-12.384-8.28 12.384-8.28v16.56zm0-18.288l-3.6 2.376V19.68c0-.432-.288-.72-.72-.72H8.16c-.432 0-.72.288-.72.72v5.4l-3.6-2.376V20.4L24 4.272 44.16 20.4v2.232z",
    fill: "#515864"
  })));
}
export default SvgEmail;